import React, { Component } from 'react'

import { Button } from 'reactstrap'

export default class maxtrixTable extends Component {
    constructor(props) {
        super(props);
        this.weightInputRef = React.createRef();
        this.attributeSelectRef = React.createRef();
        this.state = {
            selectData: this.props.attributeList,
            selectedAttr: '',
            selectedWeight: 0,
            addedArr: this.props.matrixData.data,
            addedTotal: 0,
            addDisability: true
        }
    }

    componentDidMount() {
        let addedTotalVar = 0

        if (this.state.addedArr.length !== 0) {
            this.state.addedArr.map(val => {
                addedTotalVar = addedTotalVar + parseInt(val.competency_weight)
            })
        }



        this.setState({
            addedTotal: addedTotalVar
        })
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.addedTotal !== this.state.addedTotal) {
            if (this.props.matrixData.type === 'ADD' || this.props.matrixData.type === 'EDIT') {

                if (this.state.addedTotal === 100) {
                    this.setState({
                        addDisability: false
                    })
                } else {
                    this.setState({
                        addDisability: true
                    })
                }
            }
        }
        if (prevProps.matrixData.data !== this.props.matrixData.data) {

            this.setState({
                addedArr: this.props.matrixData.data
            }, () => {
                let addedTotalVar = 0
                if (this.state.addedArr.length !== 0) {
                    this.state.addedArr.map(val => {
                        addedTotalVar = addedTotalVar + parseInt(val.competency_weight)
                    })
                }

                this.setState({
                    addedTotal: addedTotalVar
                })
            })
        }
    }

    attributeSelect = (e) => {
        let selectedText = '';
        let selectedTextId = ''
        this.state.selectData.map(val => {
            if (val.id == e.target.value) {
                selectedText = val.attribute_name
                selectedTextId = val.id
            }
        })
        this.setState({
            selectedAttr: selectedText,
            selectAttrId: selectedTextId
        })
    }
    weightInput = (e) => {
        this.setState({
            selectedWeight: parseInt(e.target.value, 10)
        })
    }
    addAttribute = () => {

        if (this.state.selectedAttr !== '' && this.state.selectedWeight > 0 && this.state.selectedWeight < 100) {

            let currentAddArr = [...this.state.addedArr]
            let addObjToArr = true
            if (currentAddArr.length !== 0) {
                currentAddArr.map(val => {
                    if (val.attribute__attribute_name === this.state.selectedAttr) {
                        addObjToArr = false
                    }
                })
            }

            let totalAddedArr = this.state.addedTotal
            totalAddedArr = totalAddedArr + this.state.selectedWeight


            if (addObjToArr !== false && totalAddedArr <= 100) {
                currentAddArr.push({
                    attribute_id: this.state.selectAttrId,
                    attribute__attribute_name: this.state.selectedAttr,
                    competency_weight: this.state.selectedWeight,
                })
                this.attributeSelectRef.current.value = '0'
                this.weightInputRef.current.value = ''
                this.setState({
                    addedArr: currentAddArr,
                    addedTotal: totalAddedArr
                })
            }

        }
    }

    removeSingleMetric = (data) => {
        let removedArr = [...this.state.addedArr]


        let totalAddedArr = 0

        removedArr.map((val, key) => {
            if (val.id === data) {
                removedArr.splice(key, 1)
            }
        })

        removedArr.map(val => {
            totalAddedArr = totalAddedArr + parseInt(val.competency_weight)
        })

        this.setState({
            addedArr: removedArr,
            addedTotal: totalAddedArr
        })
    }

    addMetricData = () => {
        if (this.state.addedTotal === 100) {
            this.props.metricAction(this.state.addedArr)
        }
    }

    render() {
        return (
            <div>
                <table className='responsiveMatrixTable' style={{ margin: '0px', marginBottom: 20, width: '100%', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 3px', borderCollapse: 'collapse' }}>
                    <thead style={{ backgroundColor: 'black', color: 'white' }}>
                        <tr >
                            <th style={{ textAlign: 'left', fontWeight: 400, padding: 5, width: '42.5%' }}>Attribute</th>
                            <th style={{ textAlign: 'left', fontWeight: 400, padding: 5, width: '42.5%' }}>Weight</th>
                            <th style={{ textAlign: 'left', fontWeight: 400, padding: 5, width: '15%' }}></th>
                        </tr>
                    </thead>
                    <tbody style={{ color: '#717171' }}>
                        {
                            this.state.addedTotal !== 100 &&
                            <tr className='responsiveMatrixTableTr'>
                                <td style={{ fontSize: '12px', padding: 5 }} className="styled-select slate">

                                    <select ref={this.attributeSelectRef} onChange={this.attributeSelect}>
                                        <option value="0">Choose an option ... </option>
                                        {this.state.selectData.map(val => (
                                            <option value={val.id}>{val.attribute_name}</option>
                                        ))}
                                    </select>
                                </td>
                                <td style={{ display: 'flex', padding: 5 }} className='responsiveMatrixTableTd'>
                                    <input type="number" min="1" max="infinity" ref={this.weightInputRef} onChange={this.weightInput} />
                                    <span>&nbsp;&nbsp;%</span>
                                </td>
                                <td style={{ padding: 5 }}  >
                                    <button type="button" onClick={() => this.addAttribute()} style={{ minWidth: '40px', margin: '0px 5px', padding: '0px 10px', lineHeight: '25px', height: '25px', fontSize: '0.8rem', border: 'none', backgroundColor: 'rgb(124, 141, 159)', color: 'white', outline: 'none', cursor: 'pointer' }}>
                                        <span className="fas fa-plus"></span>
                                    </button>
                                </td>
                            </tr>
                        }
                        {
                            this.props.matrixData.type === 'DETAILS' &&
                            this.state.addedArr.map(val => (
                                <tr  >
                                    <td style={{ padding: 5 }}>{val.attribute__attribute_name}</td>
                                    <td style={{ padding: 5 }}>{val.competency_weight} %</td>
                                </tr>
                            ))
                        }
                        {
                            this.props.matrixData.type === 'EDIT' &&
                            this.state.addedArr.map(val => (
                                <tr >
                                    <td style={{ padding: 5 }}>{val.attribute__attribute_name !== undefined ? val.attribute__attribute_name : val.attribute}</td>
                                    <td style={{ padding: 5 }}>{val.competency_weight} %</td>
                                    <td style={{ padding: 5 }}>
                                        {
                                            this.props.matrixData.type !== 'DETAILS' &&
                                            <button type="button" onClick={() => this.removeSingleMetric(val.id)} style={{ minWidth: '40px', margin: '0px 5px', padding: '0px 10px', lineHeight: '25px', height: '25px', fontSize: '0.8rem', border: 'none', backgroundColor: 'rgb(55, 65, 75)', color: 'white', outline: 'none', cursor: 'pointer' }}>
                                                <span className="fas fa-times"></span>
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))
                        }

                        {
                            this.props.matrixData.type === 'ADD' &&

                            this.state.addedArr.map(val => (
                                <tr >
                                    <td style={{ padding: 5 }}>{val.attribute__attribute_name}</td>
                                    <td style={{ padding: 5 }}>{val.competency_weight} %</td>
                                    <td style={{ padding: 5 }}>
                                        {
                                            this.props.matrixData.type !== 'DETAILS' &&
                                            <button type="button" onClick={() => this.removeSingleMetric(val.id)} style={{ minWidth: '40px', margin: '0px 5px', padding: '0px 10px', lineHeight: '25px', height: '25px', fontSize: '0.8rem', border: 'none', backgroundColor: 'rgb(55, 65, 75)', color: 'white', outline: 'none', cursor: 'pointer' }}>
                                                <span className="fas fa-times"></span>
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                        <tr>
                            <td style={{ color: 'green', padding: 5 }}>Total :</td>
                            <td style={{ color: 'green', padding: 5 }}>{this.state.addedTotal} %</td>
                        </tr>
                    </tbody>
                </table>
                {
                    this.props.matrixData.type === 'DETAILS' ?
                        <Button color="primary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.props.backFunc} className="float-right" type="button">DONE</Button>
                        :
                        <div>
                            <Button color="secondary" style={{ borderRadius: 0, margin: '0 10px' }} onClick={this.props.backFunc} type="button" >CANCEL</Button>
                            <Button color="primary" style={this.state.addDisability ? { borderRadius: 0, margin: '0 10px', cursor: 'not-allowed' } : { borderRadius: 0, margin: '0 10px' }} disabled={this.state.addDisability} onClick={this.addMetricData} className="float-right" type="button">{this.props.matrixData.type}</Button>
                        </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_components/common/Form2/maxtrixTable.js